export default __webpack_public_path__ + "img/avatar.e008be13.png";